module.exports = __webpack_public_path__ + "img/4b0436b48a12f21d1fd49a33e02e0c70.svg";